export const AmountConverter = {
  exponentialNotationToNumber: (value: string): string => {
    const splitValue = value.split('-');

    return splitValue.length === 2 ? Number(value).toFixed(Number(splitValue[1])) : value;
  },
  toDelimitedNumber: (value: string | number): string => {
    const str = value.toString();
    const [intPart, decimalPart] = str.split(".");

    const formattedInt = intPart.replace(/\d(?=(\d{3})+$)/g, "$& ");

    return decimalPart ? `${formattedInt}.${decimalPart}` : formattedInt;
  },
  toNonBreakingString: (value: string): string => {
    return value?.replace(/\s/g, '');
  }
}
